import React from "react";

const SimpleLink = ({
  href,
  children,
  className = "",
  target,
  rel,
  ...rest
}) => {
  return (
    <a href={href} className={className} target={target} rel={rel} {...rest}>
      {children}
    </a>
  );
};

export default SimpleLink;
